import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@fluentui/react';
import { noop, result } from 'underscore';
import { ValidationGroup } from '@bingads-webui-react/validation';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { withScope } from '@bingads-webui-react/scope-service';
import { withSiteMap, getRoutePathById } from '@bingads-webui-react/with-site-map';
import { AudienceSection, withoutEasyDismiss } from '@bingads-webui-campaign-react/audience-signals';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

export const getMatchListExclusionStyle = () => ({
  matchListExclusionContainer: {
    '.dmp_select_section': {
      display: 'none',
    },
  },
});


const CustomerMatchListExclusionInternal = (props) => {
  const {
    data,
    onDataChange,
    i18n,
    onGenericError,
    wizardPerfMarker,
    siteMap,
    scope,
    classes,
  } = props;

  const excludedAudiences = result(data, 'excludedAudiences', null);

  const onNavigateToAudiencesPage = useCallback((e) => {
    e.preventDefault();

    const route = getRoutePathById(siteMap, 'audiences-library');
    scope.remove(['campaignId', 'assetGroupId']);
    scope.save(route);
  }, [scope, siteMap]);

  const onValidate = useCallback((results) => {
    onDataChange(results.data);
  }, [onDataChange]);

  return (
    <ValidationGroup validationProps={{
      stopPropagation: true,
      onValidate,
    }}
    >
      <div className={classes.matchListExclusionContainer}>
        {
          // null/undefined exclusion audiences is indication that we haven't yet loaded the viewModel. AudienceSection initialize the loaded values on mount hence we want to
          // load it when data is loaded. otherwise the loaded values will never be updated in AudienceSection.
          excludedAudiences && <AudienceSection
          i18n={i18n}
          title={i18n.getString(_TL_(''))}
          descritpion={i18n.getString(_TL_('You can choose customer match list audiences you\'d like to exclude, and we won\'t show them your ads.'))}
          addLabel={i18n.getString(_TL_('Add customer match list'))}
          addPanelTitle={i18n.getString(_TL_('Add customer match list'))}
          addPanelDescription={
            <ReactTemplate
              model={{
                link: text => (<Link href={getRoutePathById(siteMap, 'audiences-library')} onClick={onNavigateToAudiencesPage} underline>{text}</Link>),
              }}
              template={i18n.getString(_TL_('Choose from your existing customer match list. To create a new list, go to {{link}}Audiences{{/link}}.'))}
            />}
          audienceType="CustomerList"
          onGenericError={onGenericError}
          validationProps={{ field: 'excludedAudiences', value: excludedAudiences }}
          wizardPerfMarker={wizardPerfMarker}
          />}
      </div>
    </ValidationGroup>
  );
};

CustomerMatchListExclusionInternal.propTypes = {
  data: PropTypes.shape({
    ExcludedAudiences: PropTypes.arrayOf(PropTypes.shape({
      Id: PropTypes.number.isRequired,
    })),
  }).isRequired,
  onDataChange: PropTypes.func.isRequired,
  i18n: PropTypes.shape({}).isRequired,
  onGenericError: PropTypes.func,
  wizardPerfMarker: PropTypes.string.isRequired,
  scope: PropTypes.shape({
    remove: PropTypes.func,
    save: PropTypes.func,
  }).isRequired,
  siteMap: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
  classes: PropTypes.shape({
    matchListExclusionContainer: PropTypes.string.isRequired,
  }).isRequired,
};

CustomerMatchListExclusionInternal.defaultProps = {
  onGenericError: noop,
};

export const CustomerMatchListExclusion = withDefaultStyles(withScope(withSiteMap(withoutEasyDismiss(CustomerMatchListExclusionInternal))), getMatchListExclusionStyle);
